import { render, staticRenderFns } from "./EditMarca.vue?vue&type=template&id=800fbb90"
import script from "./EditMarca.vue?vue&type=script&lang=js"
export * from "./EditMarca.vue?vue&type=script&lang=js"
import style0 from "./EditMarca.vue?vue&type=style&index=0&id=800fbb90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports